import {CommonConstant} from '../app.constants';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import {DatePipe} from '@angular/common';
import {ObjectUtils} from './object.utils';

export class DateUtils {
  /**
   * this method use to format the date value. Refer below url to get more details about the option
   * refer: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} dateValue
   * @param {{year: string; month: string; day: string}} options
   * @returns {any}
   */
  static formatDate(dateValue: string, options?: any, customLocale?: string) {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) {
      return null;
    }
    const locale = customLocale ? customLocale : CommonConstant.AU_LOCALE;
    let l10nEN;
    if (options) {
      l10nEN = new Intl.DateTimeFormat(locale, options);
    } else {
      l10nEN = new Intl.DateTimeFormat(locale, {year: 'numeric', month: 'short', day: 'numeric'});
    }

    return l10nEN.format(date).replace('.', '');
  }

  /**
   * convert a Date value to String
   * input can be {@link Date} or number of milliseconds
   * @param {Date | number} date
   * @param {string} format
   * @returns {string}
   */
  static convertDateToString(date: Date | number, format: string) {
    const datePipe = new DatePipe(CommonConstant.AU_LOCALE);
    return datePipe.transform(date, format);
  }

  /**
   * added a period to a specific date
   * @param {Date} date
   * @param {number} period
   * @returns {Date}
   */
  static addPerid(date: Date, period: number): Date {
    const originalDate = new Date(date.getTime());
    return new Date(originalDate.setDate(originalDate.getDate() + period));
  }

  /**
   * get current date
   * @param {Date} date
   * @param {number} period
   * @returns {Date}
   */
  static now(): Date {
    return new Date();
  }

  static computeTimeDiffInHour(date1: Date, date2: Date) {
    const timeDiff = date2.getTime() - date1.getTime();
    return timeDiff / 3600000;
  }

  /**
   * this method used to validate a date is valid NgbDateStruct
   * @param {{year: number; month: number; day: number}}
   */
  static isValidNgbDateStruct(date: NgbDateStruct) {
    if (!date) {
      return false;
    }
    if (date.year && date.month && date.day) {
      return true;
    } else {
      return false;
    }
  }

  static before(date1: Date, date2: Date) {
    if (!date1 || !date2) {
      return false;
    }
    return date1.getTime() < date2.getTime();
  }

  static after(date1: Date, date2: Date) {
    if (!date1 || !date2) {
      return false;
    }
    return date1.getTime() > date2.getTime();
  }

  static getDateSuffix(value: Date) {
    let suffix = 'th';
    const day = value.getDate();

    if (day === 1 || day === 21 || day === 31) {
      suffix = 'st';
    } else if (day === 2 || day === 22) {
      suffix = 'nd';
    } else if (day === 3 || day === 23) {
      suffix = 'rd';
    }
    return suffix;
  }

  static isValidDate(value) {
    return value instanceof Date && !isNaN(value.getTime());
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/date.utils.ts